import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { AgreementsAutocomplete, PromocodeBatchesAutocomplete, Form } from "@shared/components";

export const PromocodeListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("promocode_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <PromocodeBatchesAutocomplete
          name="batch"
          label={translate("promocode_admin.filters.batch")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("promocode_admin.filters.agreement")}
        />
      </Grid>
    </Grid>
  );
});
